import type { DocumentNode } from "graphql";

import type { Locale } from "@/i18n/i18n-config";
import { NEXT_PUBLIC_POS_SERVICE_URL } from "@/modules/config";

import { logger } from "@/modules/lib/observability/logger";
import { CookieKeys } from "@/utils/constants";
import { fetchGraphql } from "../fetch";

export const fetchPosService = async <Response, Variables>({
  query,
  variables,
  locale,
  store,
  headers = {},
}: {
  query: DocumentNode;
  variables?: Variables;
  locale?: Locale;
  store?: string;
  headers?: Record<string, string>;
  ssrAccessToken?: string;
}): Promise<Response> => {
  if (!store) {
    logger.error("[FetchPoshService]: Store is required", {
      query,
      variables,
      locale,
      store,
      headers,
    });
    throw new Error(
      `[FetchPoshService]: failed to fetch ${query}. Store is required`,
    );
  }

  if (typeof window === "undefined") {
    const cookies = await import("next/headers").then((mod) => mod.cookies);
    const cookieStore = await cookies();
    const jwt = cookieStore.get(CookieKeys.AuthCookie)?.value;
    headers.cookie = jwt ? `${CookieKeys.AuthCookie}=${jwt}` : "";
  }

  return fetchGraphql({
    url: `${NEXT_PUBLIC_POS_SERVICE_URL}/graphql`,
    query,
    variables,
    locale,
    store,
    headers,
    credentials: "include",
    shouldHandleRefreshToken: true,
  });
};
